/* eslint-disable no-undef */
import { makeStyles } from '@material-ui/core'
import SimplifiedPageWarning from '../../pages/SimplifiedPageWarning'

export const removeRoutes = (obj, dashRoutes = [], status_value) => {
    if (!Array.isArray(dashRoutes)) return [];

    const routePermissions = {
        tiers: 'allowProgramLevels',
        transferRequest: 'allowTransfer',
        scoringRules: 'allowPointsConversion',
        giftVouchers: 'allowGiftCard',
        payrollDebit: 'allowPayrollDebit',
        friends: 'allowIndications',
    };

    return dashRoutes.map(route => {
        const updatedRoute = { ...route };

        if (status_value === 'SIMPLIFY' && route?.simpleBlocked) {
            updatedRoute.component = SimplifiedPageWarning;
        }

        const permissionKey = routePermissions[route.id];

        if (permissionKey && !obj?.[permissionKey]) {
            updatedRoute.sidebar = false;
        }

        return updatedRoute;
    });
};


export const useStyles = makeStyles((theme) => ({
    root: {
        backgroundColor: theme.palette.background.paper,
    },
    nested: {
        paddingLeft: theme.spacing(4),
    },
}))
